import { Button, Typography } from "@mui/material";
import React from "react";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { StackedContainer } from "@poseidon/ui/styles/layout";
import { Link } from "react-router-dom";
import { AccountCircle } from "@mui/icons-material";
import { Avatar } from "@mui/material";

export default function AdminProfile() {
  const { user, signOut } = useAuth();

  return (
    <StackedContainer>
      <Typography variant="h3">Account</Typography>
      <Link to="/profile">
        <Avatar
          sx={{
            height: 135,
            width: 135,
            my: 4,
          }}
          src="/static/images/avatars/avatar_1.png"
        >
          <AccountCircle style={{ transform: "scale(4)" }} />
        </Avatar>
      </Link>
      <Typography>Email: {user.email}</Typography>
      <br />
      <Button onClick={() => signOut()}>Log Out</Button>
    </StackedContainer>
  );
}
